import { createAsyncThunk } from "@reduxjs/toolkit";
import Platform from "Entity/Platform";
import Api from "Vendor/Api";
import { BrandingColor, Font, FontVariant, PlatformAssets } from "Vendor/Utils/StudioTypes";

const DEFAULT_FONTS: Font[] = [
    { family: 'Montserrat', variants: [] },
    { family: 'Syne', variants: [] },
];

export const fetchAssetsThunk = createAsyncThunk<
    PlatformAssets,
    Platform[],
    { rejectValue: string }
>('assets/fetchAssets', async (platforms, { rejectWithValue }) => {
    if (!platforms || platforms.length === 0) {
        return { fonts: DEFAULT_FONTS, colors: [] };
    }

    try {
        const responses = await Promise.all(
            platforms.map((p) => Api.get(`/asset/platform/${p.id}/theme`))
        );

        const allFonts: Font[] = responses.flatMap((res) => res.data.fonts || []);
        const fontMap = new Map<string, Font>();
        allFonts.forEach((font) => {
            const existing = fontMap.get(font.family);

            if (existing) {
                const existingFiles = new Set(existing.variants.map((v) => v.file));
                const newVariants = font.variants.filter((v: FontVariant) => !existingFiles.has(v.file));

                existing.variants = [...existing.variants, ...newVariants];
            } else {
                fontMap.set(font.family, { ...font, variants: [...font.variants] });
            }
        });

        const allColors: BrandingColor[] = responses.flatMap((res) => res.data.colors || []);
        const colorMap = new Map<string, BrandingColor>();
        
        allColors.forEach((color) => {
            if (!colorMap.has(color.value)) colorMap.set(color.value, color);
        });

        return {
            fonts: Array.from(fontMap.values()),
            colors: Array.from(colorMap.values()),
        };
    } catch (err) {
        console.error('Failed to fetch assets', err);
        
        return rejectWithValue('Failed to fetch assets');
    }
});
